// Shared constants for Event components
export const clx = 'cal_event';
